module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/get-iterator.js
// module id = 308
// module chunks = 0 1